// extracted by mini-css-extract-plugin
export var deliveryRow = "_rv-a";
export var fixedHeight = "_rv-4";
export var freightLogo = "_rv-9";
export var fullWidth = "_rv-3";
export var priceColumn = "_rv-5";
export var radioSelected = "_rv-7";
export var radioUnselected = "_rv-6";
export var selectedOption = "_rv-2";
export var selectedOptionContainer = "_rv-1";
export var selection = "_rv-0";
export var tallSkeletonText = "_rv-8";